import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_PORTFOLIO_DRIFT_API =
  'INVESTMENT/FETCH_PORTFOLIO_DRIFT_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_PORTFOLIO_DRIFT_API,
  ({ user_id }) => ({
    endpoint: `/api/admin/portfolios/${user_id}/drift`,
    method: 'GET',
  })
);

export default apiCall;
